export default __webpack_public_path__ + "static/media/tutorial-hard.e8dc8936.gif";